import { LocaleValue } from "modules/hooks/use-user-preference";

export const supportedTranslationLanguages: Array<[LocaleValue, string]> = [
  ["sq", "Albanian"],
  ["zh-CN", "Chinese (Simplified)"],
  ["zh-TW", "Chinese (Traditional)"],
  ["en", "English"],
  ["tl", "Filipino"],
  ["fr", "French"],
  ["de", "German"],
  ["it", "Italian"],
  ["ja", "Japanese"],
  ["pt", "Portuguese"],
  ["ro", "Romanian"],
  ["ru", "Russian"],
  ["es", "Spanish"],
  ["vi", "Vietnamese"],
];

export const getLanguageName = (languageCode?: string | null) =>
  supportedTranslationLanguages.find(([code]) => code === languageCode)?.[1];
